(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-launch39]').forEach(banner => {
      if (banner.dataset.launch39Ready) return;
      banner.dataset.launch39Ready = 'true';
      const target = Date.parse(banner.dataset.target);
      const timer = banner.querySelector('.mono-launch39__timer');
      let interval;
      const update = () => {
        if (!banner.isConnected) { clearInterval(interval); return; }
        const remaining = Math.max(0, Math.ceil((target - Date.now()) / 1000));
        const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
        Object.entries(values).forEach(([unit, value]) => {
          const el = banner.querySelector('[data-launch39-unit="' + unit + '"]');
          const text = String(value).padStart(2, '0');
          if (el && el.textContent !== text) el.textContent = text;
        });
        timer.hidden = remaining === 0;
        if (remaining === 0) clearInterval(interval);
      };
      update();
      if (Date.now() < target) interval = setInterval(update, 1000);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
